var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('yxt-image',_vm._g({staticClass:"lc-am-image",style:(_vm.style),attrs:{"src":_vm.src,"fit":_vm.fit,"lazy":_vm.lazy,"alt":_vm.alt,"title":_vm.title,"data-id":_vm.dataId}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }